import { render, staticRenderFns } from "./IndexAkses.vue?vue&type=template&id=07c24648"
import script from "./IndexAkses.vue?vue&type=script&lang=js"
export * from "./IndexAkses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports